import React from 'react';
import { Navigate, Outlet } from 'react-router';
import { useAuthStatus } from '../hooks/useAuthStatus';
import Loader from './Loader';

// Gate for app features that require a verified email.
//   not logged in   -> sign-in
//   logged in, not verified -> verify-email screen
//   logged in + verified    -> render the route
export default function VerifiedRoute() {
  const { loggedIn, emailVerified, checkingStatus } = useAuthStatus();

  if (checkingStatus) return <Loader />;
  if (!loggedIn) return <Navigate to="/sign-in" />;
  if (!emailVerified) return <Navigate to="/verify-email" />;
  return <Outlet />;
}
